import { SUCCESS, APP_NAME, DANGER } from 'utils/constants/notifyTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { store } from 'react-notifications-component';
import { eventAddReducerTypes, eventShowReducerTypes, eventSingleShowReducerTypes } from 'types';

import { commonApiTypes } from 'types/common';

import { getToaster } from 'utils/helpers/toast';

import { eventAddState, eventShowState, eventSingleShowState } from './eventState';

const eventAddSlice = createSlice({
    name: 'eventAddSlice',
    initialState: eventAddState,
    reducers: {
        eventAddStart: (state, action: PayloadAction<eventAddReducerTypes.IEventAddForm>) => {
            return {
                ...state,
                ...action.payload,
                isLoading: true,
            };
        },
        eventAddSuccess: (state, action: PayloadAction<eventAddReducerTypes.IEventAddSuccess>) => {
            store.addNotification(getToaster(`${APP_NAME} Event`, action.payload.message, SUCCESS));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isEventAddSuccess: true,
            };
        },
        eventAddFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            store.addNotification(getToaster(`${APP_NAME} Event`, action.payload.error, DANGER));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isEventAddSuccess: false,
            };
        },
        eventAddReset: () => {
            return {
                ...eventAddState,
            };
        },
    },
});

const eventShowSlice = createSlice({
    name: 'eventShowSlice',
    initialState: eventShowState,
    reducers: {
        eventShowStart: (state, action: PayloadAction<eventShowReducerTypes.IEventShowForm>) => {
            return {
                ...state,
                ...action.payload,
                isLoading: true,
            };
        },
        eventShowSuccess: (state, action: PayloadAction<eventShowReducerTypes.IEventShowSuccess>) => {
            return {
                ...state,
                current_page: action.payload.current_page,
                last_page: action.payload.last_page,
                to: action.payload.to,
                total: action.payload.total,
                data: action.payload.data,
                isLoading: false,
                isEventShowSuccess: true,
            };
        },
        eventShowFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            store.addNotification(getToaster(`${APP_NAME} Event`, action.payload.error, DANGER));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isEventShowSuccess: false,
            };
        },
        eventShowReset: () => {
            return {
                ...eventShowState,
            };
        },
    },
});

const eventSingleShowSlice = createSlice({
    name: 'eventSingleShowSlice',
    initialState: eventSingleShowState,
    reducers: {
        eventSingleShowStart: (state, action: PayloadAction<eventSingleShowReducerTypes.IEventSingleShowForm>) => {
            return {
                ...state,
                ...action.payload,
                isLoading: true,
            };
        },
        eventSingleShowSuccess: (state, action: PayloadAction<eventSingleShowReducerTypes.IEventSingleShowSuccess>) => {
            return {
                ...state,
                data: action.payload.data,
                isLoading: false,
                isEventSingleShowSuccess: true,
            };
        },
        eventSingleShowFailed: (state, action: PayloadAction<commonApiTypes.IApiFailed>) => {
            store.addNotification(getToaster(`${APP_NAME} Event`, action.payload.error, DANGER));
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isEventShowSuccess: false,
            };
        },
        eventSingleShowReset: () => {
            return {
                ...eventSingleShowState,
            };
        },
    },
});

export { eventAddSlice, eventShowSlice, eventSingleShowSlice };
